import React from 'react';
import { CheckCircle, Handshake } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const Partners = () => {
  const { language } = useLanguage();

  const benefits = [
    language === 'es' ? 'Comisiones competitivas' : 'Competitive commissions',
    language === 'es' ? 'Soporte dedicado' : 'Dedicated support',
    language === 'es' ? 'Material de marketing' : 'Marketing materials',
    language === 'es' ? 'Capacitación continua' : 'Continuous training',
    language === 'es' ? 'Acceso prioritario a nuevas funciones' : 'Priority access to new features',
    language === 'es' ? 'Dashboard de seguimiento' : 'Tracking dashboard'
  ];

  return (
    <div className="bg-black text-white min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-green-900/20 via-black to-emerald-900/20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-green-600/20 to-emerald-600/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <Handshake className="w-10 h-10 text-green-400" />
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              {language === 'es' ? 'Programa de' : 'Partner'}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">
                {language === 'es' ? 'Partners' : 'Program'}
              </span>
            </h1>
            <p className="text-xl text-gray-200">
              {language === 'es'
                ? 'Únete a nuestra red de partners y ayuda a transformar negocios con tecnología de IA'
                : 'Join our partner network and help transform businesses with AI technology'}
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center">
              {language === 'es' ? 'Beneficios del Programa' : 'Program Benefits'}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
              {benefits.map((benefit, index) => (
                <Card key={index} className="bg-gradient-to-br from-gray-900 to-black border-green-900/30">
                  <CardContent className="p-6 flex items-center space-x-4">
                    <div className="w-12 h-12 bg-green-600/20 rounded-full flex items-center justify-center flex-shrink-0">
                      <CheckCircle className="w-6 h-6 text-green-400" />
                    </div>
                    <span className="text-lg text-white">{benefit}</span>
                  </CardContent>
                </Card>
              ))}
            </div>

            <Card className="bg-gradient-to-br from-gray-900 to-black border-green-600/30">
              <CardContent className="p-12 text-center">
                <h3 className="text-2xl md:text-3xl font-bold mb-4 text-white">
                  {language === 'es' ? '¿Listo para ser Partner?' : 'Ready to become a Partner?'}
                </h3>
                <p className="text-gray-200 mb-8 max-w-2xl mx-auto">
                  {language === 'es'
                    ? 'Comienza hoy y accede a todas las herramientas y recursos que necesitas para tener éxito'
                    : 'Start today and access all the tools and resources you need to succeed'}
                </p>
                <Link to="/contact">
                  <Button className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400 text-white rounded-full px-8 py-6 text-lg shadow-lg shadow-green-600/50">
                    {language === 'es' ? 'Aplicar Ahora' : 'Apply Now'}
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Partners;